// extracted by mini-css-extract-plugin
export default {"userInfo":"menu_userInfo__2G92C","selected":"menu_selected__YjA0f","deptArrow":"menu_deptArrow__3Je0u"};